const users = [
	{
		path: '/network/users/list',
		name: 'users-list',
		component: () => import('@/views/network/users/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,users',
		},
	},
	{
		path: '/network/users/edit/:id',
		name: 'users-edit',
		component: () => import(/* webpackChunkName: "UsersEdit" */ '@/views/network/users/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,users',
		},
	},
	{
		path: 'network/users/create',
		name: 'users-create',
		component: () => import(/* webpackChunkName: "UsersCreate" */ '@/views/network/users/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,users',
		},
	},
	{
		path: '/network/users/groups/list',
		name: 'network-users-groups-list',
		component: () => import('@/views/network/users/groups/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,users',
		},
	},
	{
		path: '/network/users/genders/list',
		name: 'network-users-genders-list',
		component: () => import('@/views/network/users/genders/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,users',
		},
	},
]

export default users
